import { createI18n } from 'vue-i18n';
import en from './locales/en.js';
import ms from './locales/ms.js';
import zh from './locales/zh.js';

export default createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    ms,
    zh
  }
});